import './BlockPlayer.scss';
class BlockPlayer {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;
        let frame = t.node.querySelector('.wrapper__frame');
        let placeholder = t.node.querySelector('.wrapper__placeholder');
        if( placeholder ) {

            placeholder.querySelector('.placeholder__button').addEventListener('click', () => {
                frame.setAttribute('src', frame.getAttribute('data-src')+'?autoplay=1&mute=1' );
                frame.setAttribute('aria-hidden','false');
                placeholder.setAttribute('aria-hidden','true');
            });
            frame.addEventListener('load', () => {
                setTimeout( () => {
                    placeholder.remove();
                }, 1000 );
            });

        } else {
            
            let observer = new IntersectionObserver(
                ( entries , settings ) => {
                    entries.forEach( ( entry, index ) => {
                        if( entry.isIntersecting ) {
                            entry.target.setAttribute('src', entry.target.getAttribute('data-src') );
                            observer.unobserve( entry.target );
                        }
                    });
                },
                {
                    threshold: 0,
                    rootMargin: '100px'
                }
            );
            observer.observe( frame );

        }
    }
}
JSModules[ 'BlockPlayer' ] = BlockPlayer;
export default BlockPlayer;